export default __webpack_public_path__ + "static/media/section1-img4.d4a0563d.png";